export default function () {
  return {
    name: new RegExp("^[а-яА-ЯЭэЪъёЁa-zA-ZЇїІіЄєҐґЎў \.\']{2,}$", 'i'),
    email: new RegExp('^[a-z0-9_]+[\\.\\-_]*[a-z0-9_]+@[a-z0-9]+[a-z0-9_\\-\\.]*[a-z0-9]+\\.[a-z0-9]{2,}$', 'i'),
    phone: new RegExp('^[0-9 \-\.\(\)\+_]{5,}$', 'i'),
    /*text: new RegExp("^[0-9а-яА-ЯЭэЪъёЁa-zA-ZЇїІіЄєҐґЎў \.\'\(\)\"«»]{2,}$", 'i')*/
  }
}
